import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Edge} from "../types/Edge";

const emptyArray: Edge[] = [];

export const useGetEdges = (dealerID: number, prodQteGrpID: number, pricingDate: Date, zipCode: string, enabled: boolean) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-tool-edges', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-tool/edges?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&pricingDate=' + pricingDate.toISOString() + '&zipCode=' + zipCode) as Edge[],
        enabled: prodQteGrpID > 0 && enabled,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || emptyArray,
        isLoading: isLoading
    };
};
